import React from "react";
import { twMerge } from "tailwind-merge";

import { THead } from "./components/THead";
import { TCell } from "./components/TCell";
import type { TableColumn, TableProps } from "./types";

export function SupTable<R extends object>({ className, rowClassName, columns, data, rowId = "index", onRowClick, onCellClick }: TableProps<R>) {
  const rowIdGetter = typeof rowId === "function" ? rowId : (row: R): string => row[rowId as keyof R] as string;

  function handleCellClick(row: R, col: TableColumn<R>) {
    return () => {
      onRowClick?.(row);
      onCellClick?.(row, col);
    };
  }

  return (
    <table className={twMerge("sup-table w-full", className)}>
      <thead className="sup-table-head">
        <tr className="sup-table-head-row bg-neutral-25 border-b-0.5 border-neutral-100">
          {columns.map(col => (
            <THead key={col.field} className={col.headerCellClassName} title={col.headerName} width={col.width} minWidth={col.minWidth} maxWidth={col.maxWidth} align={col.align} />
          ))}
        </tr>
      </thead>

      <tbody className="sup-table-body">
        {data.map((row, i) => (
          <tr key={rowId === "index" ? i : rowIdGetter(row)} className={twMerge("sup-table-row h-[3.25rem] hover:bg-primary-25", rowClassName)}>
            {columns.map(col => (
              <TCell
                key={col.field}
                className={col.cellClassName}
                align={col.align}
                colSpan={col.colSpan}
                content={col.renderCell?.(row, i) ?? (row[col.field as keyof R] as string)}
                onClick={handleCellClick(row, col)}
              />
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
